import ComponentBase from "../../public/component/component_base";
import { IUserData } from "../../public/model_data";
import UserDataManager from "../../../manager/user_manager";
import { Hallx } from "../../hall/server/club/proto_club_hall_notify";
import GameUtil from "../../../utility/game_util";
import Utility from "../../../utility/utility";
import { club_utils } from "../club_utils";

const {ccclass, property} = cc._decorator;


class tablePos{

    static readonly FOUR_PLAYER_ARRAY_0 = [cc.v2(-246.5,67.525)
        ,cc.v2(-92.326,-64.91)
        ,cc.v2(85.513,-64.91)
        ,cc.v2(235.493,67.525)];

    static readonly FOUR_PLAYER_ARRAY_1 = [cc.v2(-246.5,67.525)
            ,cc.v2(-236.692,-48.671)
            ,cc.v2(223.165,-48.671)
            ,cc.v2(235.493,67.525)];   

    static readonly FIVE_PLAYER_ARRAY = [cc.v2(-246.5,67.525)
        ,cc.v2(-236.692,-40.254)
        ,cc.v2(-1.028,-68.254)
        ,cc.v2(225.784,-40.254)
        ,cc.v2(235.493,67.525)];  

    static readonly SIX_PLAYER_ARRAY = [cc.v2(-226.501,64.293)
            ,cc.v2(-234.369,-49.005)
            ,cc.v2(-69.174,-65.358)
            ,cc.v2(58.211,-65.358)
            ,cc.v2(220.654,-49.005)
            ,cc.v2(213.37,64.293)];  

    static readonly SEVEN_PLAYER_ARRAY = [cc.v2(-146.175,122.564)
        ,cc.v2(-246.5,67.525)
        ,cc.v2(-236.692,-48.671)
        ,cc.v2(-1.028,-68.254)
        ,cc.v2(225.784,-48.671)
        ,cc.v2(235.493,67.525)
        ,cc.v2(136.024,122.564)];     
        
    static readonly EIGHT_PLAYER_ARRAY = [cc.v2(-146.175,122.564)
        ,cc.v2(-246.5,67.525)
        ,cc.v2(-236.692,-48.671)
        ,cc.v2(-89.345,-68.254)
        ,cc.v2(83.823,-68.254)
        ,cc.v2(225.784,-48.671)
        ,cc.v2(235.493,67.525)
        ,cc.v2(136.024,122.564)];  

    static readonly NINE_PLAYER_ARRAY = [cc.v2(-146.175,122.564)
            ,cc.v2(-246.5,67.525)
            ,cc.v2(-240.484,-48.671)
            ,cc.v2(-137.377,-68.254)
            ,cc.v2(-1.497,-68.254) 
            ,cc.v2(126.56,-68.254)
            ,cc.v2(227.048,-48.671)
            ,cc.v2(235.493,67.525)
            ,cc.v2(136.024,122.564)];               

    static POS_MAP = {"CLUB_Q2" : tablePos.FOUR_PLAYER_ARRAY_0 ,
                  "CLUB_QZNN" : tablePos.FOUR_PLAYER_ARRAY_1 ,
                  "CLUB_HJK" : tablePos.FIVE_PLAYER_ARRAY ,
                  "CLUB_BP" : tablePos.FIVE_PLAYER_ARRAY ,
                  "CLUB_BPZD" : tablePos.FIVE_PLAYER_ARRAY ,
                  "CLUB_SLOT" : tablePos.SIX_PLAYER_ARRAY ,
                  "CLUB_JD" : tablePos.SEVEN_PLAYER_ARRAY ,
                  "CLUB_DZPK" : tablePos.SEVEN_PLAYER_ARRAY ,
                  "CLUB_CP" : tablePos.SEVEN_PLAYER_ARRAY ,
                  "CLUB_LHD" : tablePos.SEVEN_PLAYER_ARRAY ,
                  "CLUB_BJL" : tablePos.SEVEN_PLAYER_ARRAY ,
                  "CLUB_JK" : tablePos.SEVEN_PLAYER_ARRAY ,
                  "CLUB_TB" : tablePos.NINE_PLAYER_ARRAY ,
                  "CLUB_YXX" : tablePos.NINE_PLAYER_ARRAY 
                  
                }

            
    static getGameTablePos(gameName : string){

        return this.POS_MAP[gameName];
    }       
    
    static getPos(gameName : string,seatIndex :number){

        let posArray = this.getGameTablePos(gameName);

        if (posArray.length > seatIndex ) {
            
            return posArray[seatIndex];
        }

        cc.error(" seatIndex error " ,seatIndex);
        return new cc.Vec2;
    }

    static getMaxNum(gameName : string){
        
        return this.POS_MAP[gameName] ? this.POS_MAP[gameName].length : 0;
    }
}

@ccclass
export default class ClubHallPlayer extends ComponentBase {


    @property(cc.Sprite)
    iconSprite : cc.Sprite = null;

    // @property(cc.Label)
    // nameLabel : cc.Label = null;


    refresh(gameName : string, seatIndex : number, playerInfo : Hallx.IPlayerInfo){

        if ( tablePos.getMaxNum(gameName) <= seatIndex ) {
            
            this.node.active = false;
        }
       
        else{

            //this.node.active = gameName != "CLUB_SLOT";        

            this.node.active = false;

            if (seatIndex < 0) {

                this.node.active = false;
                cc.error(" game " , gameName, " playerId " ,playerInfo.id , " seatIndex < 0");
                
            }else{
                this.node.position = tablePos.getPos(gameName,seatIndex);    
            }
            

            // if (!playerInfo.nickname) {
            //     console.error(" can not find property -> PlayerInfo.nickname ");
            // }else{
            // // this.nameLabel.string =  Utility.strClamp(playerInfo.nickname,5);
            // }

            //暂时不显示名字 
            // this.nameLabel.node.active = false;
                    
            if (!playerInfo.avatar) {
                console.error(" can not find property -> PlayerInfo.avatar ");
            }else{
                let self = this;
                UserDataManager.getAvatarSprite(playerInfo.avatar,(frame)=>{
                    self.node.active = true;
                    self.iconSprite.spriteFrame = frame;                                                                   
                })
            }
        }                       
       
    }

    clear(){
        
        // this.nameLabel.string = "";
        if (this.iconSprite.spriteFrame ) {
            this.iconSprite.node.active = false;
            //this.iconSprite.spriteFrame = null;    
        }
        
        
    }

}
